const ONBOARDING_START = 'On-Boarding: Start';
const ONBOARDING_ACCOUNT_INFORMATION = 'On-Boarding: Account Information';
const ONBOARDING_COMPANY_INFORMATION = 'On-Boarding: Company Information';
const ONBOARDING_COMPLETED = 'On-Boarding: Completed';

const onboardingAnalyticsConstants = {
  ONBOARDING_START,
  ONBOARDING_ACCOUNT_INFORMATION,
  ONBOARDING_COMPANY_INFORMATION,
  ONBOARDING_COMPLETED,
};

export default onboardingAnalyticsConstants;
